<template>
    <div class="inquiry">
      <div class="icon-help">
        <img src="../../../images/project-img/Icon-help-circle.svg" alt="Icon help">
      </div>
      <div class="inquiry-box">
        <p>{{ description }}</p>
        <a :href="mailLink" target="_blank">{{ mailText }}</a>
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 6 10.2">
            <g id="Arrow-Small_down" data-name="Arrow-Small down" transform="translate(0 10.2) rotate(-90)">
              <path id="Arrow-Small_down-2" data-name="Arrow-Small down" d="M4.338.9A1,1,0,0,1,5.862.9L8.8,4.352A1,1,0,0,1,8.038,6H2.162A1,1,0,0,1,1.4,4.352Z" transform="translate(10.2 6) rotate(180)" fill="#ffffff"/>
            </g>
          </svg>
        </span>
      </div>
    </div>
  </template>

  <script>
  export default {
    name: 'Inquiry',
    props: {
      description: {
        type: String,
        default: 'Qualcosa è andato storto?'
      },
      textMailTo: {
        type: String,
        default: 'Scrivici'
      },
      email: {
        type: String,
        default: 'info.auto@edidomus.it'
      }
    },
    computed: {
      mailLink() {
        if (this.email && this.email.includes('@')) {
          return 'mailto:' + this.email;
        }
        return this.email;
      },
      mailText() {
        return `${this.textMailTo}`;
      }
    }
  };
  </script>



// WEBPACK FOOTER //
// resources/js/app/components/Inquiry.vue